import { emailValidator } from '@acme/b2b/validators';

export function isInternalUser(email: string | null | undefined): boolean {
  if (!emailValidator(email ?? '')) {
    return false;
  }

  const domain = email?.split('@')[1];

  return domain === 'acmeticketing.com' || domain === 'peek.com';
}
